import React, { useState } from "react";
import insuranceDetailsService from "../insuranceDetails/insuranceDetailsService";
import TooltipInput from "../../NewUPT/ToolTip/TooltipInput";
import "../registration/ptRegDesign.css";

const insuranceService = new insuranceDetailsService();

const RegisterInsurance = () => {
  const [form, setForm] = useState({
    insName: "",
    days: "",
    authorization: "",
    insCode: "",
    address: "",
    acceptance: "",
    coverageName: "",
  });
  const [image, setImage] = useState(null);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const insuranceDetail = {
      insName: form.insName.trim(),
      days: parseInt(form.days.trim(), 10),
      authorization: form.authorization.trim(),
      insCode: form.insCode.trim(),
      address: form.address.trim(),
      acceptance: form.acceptance.trim(),
      coverageName: form.coverageName.trim(),
    };

    try {
      const formData = new FormData();
      formData.append("insuranceDetail", new Blob([JSON.stringify(insuranceDetail)], { type: "application/json" }));
      if (image) formData.append("image", image);

      const response = await insuranceService.addInsuranceDetail(formData);
      alert("Insurance Registration Successful: " + JSON.stringify(response));
    } catch (error) {
      alert("Registration Failed: " + error.message);
    }
  };

  return (
      <div className="form-wrapper">
    <form id="insuranceRegistrationForm" onSubmit={handleSubmit} encType="multipart/form-data">
      <TooltipInput
        type="text"
        id="insName"
        placeholder="Enter Insurance Name"
        tooltip="The name of the insurance provider."
        value={form.insName}
        onChange={(v) => handleChange("insName", v)}
      />
      <TooltipInput
        type="number"
        id="days"
        placeholder="Enter Number of Days"
        tooltip="Number of coverage days."
        value={form.days}
        onChange={(v) => handleChange("days", v)}
      />
      <TooltipInput
        type="text"
        id="authorization"
        placeholder="Enter Authorization"
        tooltip="Authorization code or details."
        value={form.authorization}
        onChange={(v) => handleChange("authorization", v)}
      />
      <TooltipInput
        type="text"
        id="insCode"
        placeholder="Enter Insurance Code"
        tooltip="Unique code for the insurance."
        value={form.insCode}
        onChange={(v) => handleChange("insCode", v)}
      />
      <TooltipInput
        type="text"
        id="address"
        placeholder="Enter Address"
        tooltip="The address of the insurance company."
        value={form.address}
        onChange={(v) => handleChange("address", v)}
      />
      <TooltipInput
        type="text"
        id="acceptance"
        placeholder="Enter Acceptance Status"
        tooltip="Accepted or not."
        value={form.acceptance}
        onChange={(v) => handleChange("acceptance", v)}
      />
      <TooltipInput
        type="text"
        id="coverageName"
        placeholder="Enter Coverage Name"
        tooltip="Type of coverage provided."
        value={form.coverageName}
        onChange={(v) => handleChange("coverageName", v)}
      />

      <div className="image-upload">
        <label htmlFor="image">Upload Insurance Image</label>
        <input
          type="file"
          id="image"
          accept="image/*"
          onChange={(e) => setImage(e.target.files[0])}
        />
      </div>

      <button type="submit">Register Insurance</button>
    </form>
    </div>
  );
};

export default RegisterInsurance;
